export function completeWithZeros(value, length) {
    var zeros = "0".repeat(length - value.length);
    return zeros + value;
}
